export const NAV_BASE_CLASS =
  'py-1.5 px-1.5 2xl:px-2.5 text-primary hover:text-high-emphesis focus:text-high-emphesis whitespace-nowrap font-bold text-sm 2xl:text-[15px]'

export const ACTIVE_NAV_LINK_CLASS =
  'font-bold text-high-emphesis rounded-md underline underline-offset-4 decoration-2 decoration'
